import React, { Component } from "react";
import BulkEdit from "../bulkEdit/BulkEdit";
class BulkEditPageLayout extends Component {
  render() {
    return (
      <BulkEdit
        shouldModalOpen={this.props.shouldModalOpen}
        toggleBulkEditForm={this.props.toggleBulkEditForm.bind(this)}
      />
    );
  }
}

export default BulkEditPageLayout;
